import { render } from "./CanIGo.vue?vue&type=template&id=3a817eb4"
import script from "./CanIGo.vue?vue&type=script&lang=js"
export * from "./CanIGo.vue?vue&type=script&lang=js"
script.render = render

export default script